import styled from 'styled-components';

export const TableItem = styled.span`
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;

  color: ${({ theme }) => theme.colors.grey600};
`;

export const PointsIcon = styled.span`
  display: inline-block;
  position: relative;
  width: 16px;
  height: 16px;
  margin-right: 8px;
  background: linear-gradient(
    180deg,
    ${({ theme }) => theme.colors.yellowMain} 2.61%,
    ${({ theme }) => theme.colors.yellowDark} 100%
  );
  border-radius: 50%;
  &::after {
    content: ${'"\\e912"'};
    position: absolute;
    font-family: 'icomoon' !important;
    font-size: 16px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: ${({ theme }) => theme.colors.orangeDark};
  }
`;

export const TypeCol = styled(TableItem)`
  color: ${({ theme, earned }) => (earned ? theme.colors.greenMain : theme.colors.orangeMain)};
`;

export const TypeIcon = styled.span`
  display: inline-block;
  position: relative;
  width: 16px;
  height: 16px;
  margin-right: 8px;
  background: ${({ theme, earned }) => (earned ? theme.colors.greenMain : theme.colors.orangeMain)};
  border-radius: 50%;
  &::after {
    content: ${({ earned }) => (earned ? '"\\e910"' : '"\\e90e"')};
    position: absolute;
    font-family: 'icomoon' !important;
    font-size: 8px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: ${({ theme }) => theme.colors.white};
  }
`;

export const GridWrapper = styled.div`
  padding: 0 24px;
`;
export const Row = styled.div`
  display: grid;
  grid-template: 1fr / 1.5fr 2.5fr 1fr 1.5fr 1.5fr 1fr 1fr;
  column-gap: 16px;
`;
export const Divider = styled.hr`
  width: calc(100% + 48px);
  grid-column: 1 / 13;
  margin: 0 -24px;
  border: 0;
  border-top: 1px solid ${({ theme }) => theme.colors.grey200};
`;

export const HeaderItem = styled.div`
  padding: 14px 8px;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.grey002};
  text-align: start;
`;

export const ColumnItem = styled.div`
  padding: 14px 8px;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  text-align: start;
`;

export const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
`;
